import React from "react";
import { $t } from './i18n';

const CSession = ({title, children, id}) => (
  <section id={id} className="c-session">
    <h2 className="c-section-title">{$t(title)}</h2>
    { children }
  </section>
)

export default CSession;
